import { createAction } from 'redux-actions';
/** Overwrites the store state. Do not use outside of storybook */
export var setFirstTimeFlags = createAction('@@firstTimeFlags/SET_FLAGS', function (payload) { return payload; });
/** Drop a particular FTUE flag */
export var dropFirstTimeFlag = createAction('@@firstTimeFlags/DROP_FLAG', function (payload) { return payload; });
/** Drop a particular FTUE flag, but with less annoying API (identical in
 * effect to dropFirstTimeFlag) */
export var dropFirstTimeFlagSimple = function (flag, redirectTo) { return dropFirstTimeFlag({ flag: flag, redirectTo: redirectTo }); };
/** Unset a particular FTUE flag in the store only.
 * Does NOT persist on backend, do not use unless you know what you're doing. */
export var unsetFirstTimeFlag = createAction('@@firstTimeFlags/UNSET_FLAG', function (flag) { return ({ flag: flag }); });
//# sourceMappingURL=actions.js.map